import { render, staticRenderFns } from "./multiindex.vue?vue&type=template&id=c340b36e&scoped=true&"
import script from "./multiindex.vue?vue&type=script&lang=js&"
export * from "./multiindex.vue?vue&type=script&lang=js&"
import style0 from "./multiindex.vue?vue&type=style&index=0&id=c340b36e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c340b36e",
  null
  
)

export default component.exports